import { Service } from './http-service';
import {
  type CalculatePricePerExtraKmResponseDto,
  type GetDepositResponseDto,
  type GetMinAgeResponseDto,
  type UpdateYieldManagementSettingsDto,
  type YieldManagementSettings,
  type YieldManagementSettingsControllerCalculatePricePerExtraKmData,
  type YieldManagementSettingsControllerGetDepositData,
  type YieldManagementSettingsControllerGetMinAgeData,
} from '@carvia/ros-client-types';

class YieldManagementSettingsService extends Service<
  YieldManagementSettings,
  UpdateYieldManagementSettingsDto,
  undefined
> {
  async getYieldManagementSettings() {
    const res = await this.httpClient.get<YieldManagementSettings>(this.endpoint);
    return res.data;
  }

  async updateYieldManagementSettings(dto: UpdateYieldManagementSettingsDto) {
    const res = await this.httpClient.patch<YieldManagementSettings>(this.endpoint, dto);
    return res.data;
  }

  async calculatePricePerExtraKm(
    query: YieldManagementSettingsControllerCalculatePricePerExtraKmData['query'],
  ) {
    const res = await this.httpClient.get<CalculatePricePerExtraKmResponseDto>(
      this.endpoint + '/calculate-price-per-extra-km',
      {
        params: query,
      },
    );
    return res.data;
  }

  async getDeposit(query: YieldManagementSettingsControllerGetDepositData['query']) {
    const res = await this.httpClient.get<GetDepositResponseDto>(this.endpoint + '/get-deposit', {
      params: query,
    });
    return res.data;
  }

  async getMinAge(query: YieldManagementSettingsControllerGetMinAgeData['query']) {
    const res = await this.httpClient.get<GetMinAgeResponseDto>(this.endpoint + '/get-min-age', {
      params: query,
    });
    return res.data;
  }
}

export const yieldManagementSettingsService = new YieldManagementSettingsService(
  '/yield-management-settings',
);
